import Link from 'next/link'

interface LinkComponentProps {
    pathName: string
    query: Record<string, string | number | undefined>
    value?: string
    children?: JSX.Element
    asValue: string
}

const LinkComponent = ({ pathName, query, value, children, asValue }: LinkComponentProps) => {
    return (
        <Link
            data-test="link"
            href={{
                pathname: pathName,
                query: query,
            }}
            passHref
            style={{
                color: 'rgba(15, 79, 255, 1)',
                fontSize: '16px',
            }}
            as={asValue}
        >
            {value ? value : children}
        </Link>
    )
}

export default LinkComponent
